/**
 * Resets pagination to the first page (page 0) if currently on a later page.
 * This is useful before mutations that remove items to ensure consistent behavior after refetch.
 *
 * @param searchParams - Current URLSearchParams instance
 * @param setSearchParams - Function to update search params
 * @param pageParamKey - Optional page parameter key (defaults to 'page')
 */
export const resetPageToFirst = (
  searchParams: URLSearchParams,
  setSearchParams: (params: URLSearchParams | ((prev: URLSearchParams) => URLSearchParams)) => void,
  pageParamKey: string = 'page',
): void => {
  const currentPage = Number(searchParams.get(pageParamKey) || '0');
  if (currentPage > 0) {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set(pageParamKey, '0');
    setSearchParams(newSearchParams);
  }
};
